export enum SelectDirection {
  BOTTOM = 'bottom',
  TOP = 'top',
}
